import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { FileUploadService } from '../../../../shared/providers/fileupload.service';
import { IFileUpload } from '../../../../shared/models/fileupload';
import { ToastService } from '../../../../shared/providers/toast.service';
import { LoaderService } from '../../../../shared/providers/loader.service';
import { DashboardService } from '../../../../shared/providers/dashboard.service';
import { PropertyManagementService } from '../../../../shared/providers/property-management.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { AuthenticationService } from '../../../../shared/auth/authentication.service';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-bov-ready-for-review',
  templateUrl: './bov-ready-for-review.component.html',
  styleUrls: ['./bov-ready-for-review.component.css']
})
export class BovReadyForReviewComponent implements OnInit {

  @Input() propertyId: number;
  fileExtensionType = 'document'
  fileUploadType = 'single';
  selectedFiles: string[] = [];
  selectedFilesForDocs: string[] = [];
  inputFileUpload = {} as IFileUpload;
  errorMessage: string;
  fileTypes = '.PDF, .XLSX, .XLS, .DOCX, .DOC, .TXT, .DWG'
  clearFiles: number = 0;
  filesCollection = [];
  user: any;
  document: any;
  utm_id: string;
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  utm_term: string;
  utm_content: string;
  imageURL: string;
  @ViewChild('template') template: TemplateRef<any>;
  removeModalRef: BsModalRef;
  documentPreview: BsModalRef;
  docPreview: any;
  IsAdmin: boolean = false;
  IsSeller: boolean = false;
  IsBroker: boolean = false;
  removeDocModalRef: BsModalRef;

  constructor(private _fileUploadService: FileUploadService,
    private _toastService: ToastService,
    private modalService: BsModalService,
    private _loaderService: LoaderService,
    private _dashboardService: DashboardService,
    private _propertyManagementService: PropertyManagementService,
    private _modalService: BsModalService,
    private activatedRoute: ActivatedRoute,
    private _authenticationService: AuthenticationService,
  ) {
  }


  ngOnInit() {
    this.getDoc();
    this.IsAdmin = (this._authenticationService.Admin() || this._authenticationService.SuperAdmin());
    this.IsSeller = this._authenticationService.Seller();
    this.IsBroker = this._authenticationService.Broker();
    this.user = this._authenticationService.user;
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      
      this.utm_id = params['utm_id'] ?? params['utmid'];
      this.utm_source = params['utm_source'] ?? params['utmsource'];
      this.utm_medium = params['utm_medium'] ?? params['utmmedium'];
      this.utm_campaign = params['utm_campaign'] ?? params['utmcampaign'];
      this.utm_term = params['utm_term'] ?? params['utmterm'];
      this.utm_content = params['utm_content'] ?? params['utmcontent'];
    });
  }

  selectedFilesListEmitter(selectedFilesListEmitter: string[]) {
    this.filesCollection = [];
    this.errorMessage = null;
    this.selectedFiles = selectedFilesListEmitter;
    this.clearFiles++; //this.filesCollection = [];
    this.selectedFiles.forEach(item => {
      const fileObj =
      {
        name: item["name"],
        category: 416, // BOV Document
        file: item
      }
      this.filesCollection.push(fileObj);
    });

    this.removeModalRef = this._modalService.show(this.template, { class: 'deletemodal' });
  }

  uploadFiles() {
    this._loaderService.display(true);
    let valid = true;
    if (valid) {
      let uploadCount = 1;
      this.filesCollection.forEach(item => {
        this.inputFileUpload.documentName = item["name"];
        this.inputFileUpload.fileCategoryId = item["category"];
        this.inputFileUpload.id = 0;
        this.inputFileUpload.objectId = this.propertyId;
        this.inputFileUpload.objectTypeId = 314;
        this.inputFileUpload.type = "Documents";

        let fileToUpload = [];
        fileToUpload.push(item["file"]);
        this._fileUploadService.uploadFiles(this.inputFileUpload, fileToUpload).subscribe(res => {
          if (res != null) {
            if (uploadCount == this.filesCollection.length) {
              //this.fileUploaded.emit();

              //this.onFilesClear();
              this._loaderService.display(false);
              this._toastService.addToast({ title: 'Success', msg: "Files Uploaded Successfully", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
              //this.dtElement.dtInstance.then(x => x.draw(false));
              this.getDoc();
            }
            uploadCount++;
          }
        });
      });
      this.clearFiles++;
    }
  }

  getDoc() {
    this._dashboardService.GetBOEPropertyDocumentForReview(this.propertyId).subscribe(res => {
      this.document = res;
      this.imageURL = this.document.Thumbnail;
    })
  }

  onRemoveDocument() {
    if (this.document.Id) {
      this._loaderService.display(true);
      this._propertyManagementService.deleteDocument(this.document.Id, this.user.Id).subscribe(response => {
        if (response) {
          this.uploadFiles();
        }
      });
    }
    else {
      this.uploadFiles();
    }
  }

  previews(template: TemplateRef<any>, classes, document) {
    this.docPreview = document;
    this.documentPreview = this.modalService.show(template, { class: classes });
    this.saveBOVDownloadToAuditLog(document.Id,'Preview')
  }

  removeModel(template: TemplateRef<any>, classes, document) {
    this.removeDocModalRef = this._modalService.show(template, { class: classes });
  }
  deleteDoc() {
    this._propertyManagementService.deleteDocument(this.document.Id, this.user.Id).subscribe(response => {
      if (response) {
        this._toastService.addToast({ title: 'Success', msg: "Files Removed Successfully", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' });
        this.getDoc();
      }
    });
  }

  saveBOVDownloadToAuditLog(DocumentId: number, Action: string) {
    if (this.user != null) {
      var constData = {
        UtmId: this.utm_id,
        UtmSource: this.utm_source,
        UtmMedium: this.utm_medium,
        UtmCampaign: this.utm_campaign,
        UtmTerm: this.utm_term,
        UtmContent: this.utm_content,
        Propertyid: this.propertyId,
        UserId: this.user.Id,
        DocumentId: DocumentId,
        ActionType: Action
      };

      this._propertyManagementService.saveBOVDownloadToAuditLog(constData).subscribe(response => {
        ////this.bindLeadSummary();            
      });
    }
  }
}

